import React, { useEffect, useContext, useState, useRef } from 'react';
import { Button, Input, Select, MapDemoContext } from '..';
import axios from 'axios';
import { Link } from 'react-router-dom';
import URL from './../../URL';
import './demo-intro.css';
// import { getDemoById } from "../../list";
import { demoApiKey } from './../../config.develop';

function DemoIntro() {
  const apiKeyInput = useRef(null);

  let methodOptions = {
    دستی: '1',
  };

  let inputMethodOptions = {
    'انتخاب روی نقشه': '1',
    'وارد کردن مختصات جغرافیایی': '2',
  };

  // const [method, setMethod] = useState("انتخاب روش ورود اطلاعات");
  const [validateMessage, setvalidateMessage] = useState('');

  const start = (
    demo,
    apiKey,
    setApiKey,
    inputMethod,
    updateInputMethod,
    setPage,
    setvalidateMessage
  ) => {
    let methodSelectEl = document.querySelector('.web-view .form')
      .childNodes[0];
    let inputdMethodSelectEl = document.querySelector('.web-view .form')
      .childNodes[1];
    let apiKeyInputEl = document.querySelector('.web-view .form').childNodes[2]
      .childNodes[1];

    let SelectedMethod = [...methodSelectEl.children].filter(
      (c) => c.value === methodSelectEl.value
    )[0].label;
    let SelectedInputMethod = [...inputdMethodSelectEl.children].filter(
      (c) => c.value === inputdMethodSelectEl.value
    )[0].label;

    if (!(SelectedMethod in methodOptions)) {
      setvalidateMessage('لطفا روش ورود اطلاعات را انتخاب کنید.');
      return;
    }
    if (!(SelectedInputMethod in inputMethodOptions)) {
      setvalidateMessage('لطفا روش انتخاب نقاط را انتخاب کنید.');
      return;
    }
    if (apiKeyInputEl.value.length < 700) {
      setvalidateMessage(
        'لطفا از معتبر بودن کلید دسترسی خود اطمینان حاصل کنید.'
      );
      return;
    } else {
      // all good to go

      // Store last 3 apiKey used in localStorage
      let previousApiKeys = localStorage.getItem('apiKeys');
      previousApiKeys = previousApiKeys ? JSON.parse(previousApiKeys) : [];
      if (!previousApiKeys.includes(apiKey)) {
        if (previousApiKeys.length >= 3) {
          previousApiKeys.splice(-1, 1); // remove last item
        }
        previousApiKeys.push(apiKey);
        localStorage.setItem('apiKeys', JSON.stringify(previousApiKeys));
      }

      // check apiKey be valid by sending an AJAX
      axios({
        method: 'GET',
        url: URL.fastReverse,
        headers: {
          'x-api-key': apiKey,
        },
        params: {
          lat: 35.7,
          lon: 51.38,
        },
      })
        .then(function (res) {
          // apiKey was valid

          setApiKey(apiKey);
          switch (demo) {
            case 'Tsp':
              setPage('MapDemo');
              break;
            case 'Vrp':
              setPage('DemoVRPInfo');
              break;
            default:
              break;
          }
        })
        .catch(function (err) {
          // apiKey was invalid
          try {
            if (err.response.status === 401)
              setvalidateMessage(
                'لطفا از معتبر بودن کلید دسترسی خود اطمینان حاصل کنید.'
              );
          } catch (err) {}
        });
    }
  };

  // opens apiKey tutorial by clicking on (i) icon
  const handleInputIcon = () => {
    window.open('/help/api-key');
  };

  const { env, updateInputMethod } = useContext(MapDemoContext);

  useEffect(() => {
    if (env === 'development') {
      if (document.querySelector('.form')) {
        const form = document.querySelector('.form').childNodes;
        form[0].value = '1';
        form[1].value = '2';
        form[2].querySelector('input').value = demoApiKey;
        let event = document.createEvent('HTMLEvents');
        event.initEvent('input', true, true);
        event.eventName = 'input';
        form[2].querySelector('input').dispatchEvent(event);
        updateInputMethod('2');
      }
    }
  }, [env, updateInputMethod]);

  return (
    <MapDemoContext.Consumer>
      {({
        apiKey,
        setApiKey,
        demo,
        inputMethod,
        updateInputMethod,
        setPage,
        env,
      }) => {
        let previousApiKeys = localStorage.getItem('apiKeys');
        previousApiKeys = previousApiKeys ? JSON.parse(previousApiKeys) : [];
        return (
          <div className="demo-intro-main">
            <div className="mobile-view">
              <div className="mobile-view-bg"></div>
              <p>برای مشاهده راهکار به نسخه دسکتاپ سایت مراجعه فرمایید.</p>
              <Link to={'/'}>
                <Button>بازگشت به صفحه اصلی</Button>
              </Link>
            </div>

            <div className="web-view">
              <div className="form">
                <Select
                  placeholder={'* روش ورود اطلاعات'}
                  onChange={(e) => {
                    setvalidateMessage('');
                    // setMethod(e.target.value);
                  }}
                >
                  {methodOptions}
                </Select>
                <Select
                  placeholder={'* روش انتخاب نقاط'}
                  onChange={(e) => {
                    setvalidateMessage('');
                    updateInputMethod(e.target.value);
                  }}
                >
                  {inputMethodOptions}
                </Select>
                <Input
                  placeholder={'* کلید دسترسی'}
                  secondary
                  // autoComplete="one-time-code"
                  ref={apiKeyInput}
                  icon
                  iconHandler={handleInputIcon}
                  onInput={(e) => {
                    setvalidateMessage('');
                    setApiKey(e.target.value);
                  }}
                  onFocus={(e) => setApiKey(e.target.value)}
                  datalist={previousApiKeys}
                  defaultValue={apiKey}
                />
                <div className="start-button-wrapper">
                  <Button
                    className="btn"
                    primary
                    onClick={() =>
                      start(
                        demo,
                        apiKey,
                        setApiKey,
                        inputMethod,
                        updateInputMethod,
                        setPage,
                        setvalidateMessage
                      )
                    }
                  >
                    شروع
                  </Button>
                  <span>{validateMessage}</span>
                </div>
              </div>
              <div
                className="tsp-img"
                style={{
                  display: `${demo.toLowerCase() === 'tsp' ? 'block' : 'none'}`,
                }}
              ></div>
              <div
                className="vrp-img"
                style={{
                  display: `${demo.toLowerCase() === 'vrp' ? 'block' : 'none'}`,
                }}
              ></div>
            </div>
          </div>
        );
      }}
    </MapDemoContext.Consumer>
  );
}

export default DemoIntro;
